//PC 点货
export const TALLY_SET_LOCK = "SET_LOCK";
export const TALLY_SET_PICI_GOODS_NUM = "SET_PICI_GOODS_NUM";
export const TALLY_SET_UPSHELE_NO = "SET_UPSHELE_NO";
export const TALLY_SET_BOX_NO = "SET_BOX_NO";
export const TALLY_SET_BLP_BOX_NO = "SET_BLP_BOX_NO";
export const TALLY_SET_NO_DATA_BOX_NO = "SET_NO_DATA_BOX_NO";
export const TALLY_SET_SUIT_PARTS_BOX_NO = "SET_SUIT_PARTS_BOX_NO";



// WEBPACK FOOTER //
// ./src/store/mutation-types.js